import React from 'react';
import { Container, Typography, Box, Chip } from '@mui/material';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

const chipVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const Skills = ({ skills }) => {
  return (
    <Container
      maxWidth="md"
      sx={{ my: 8 }}
      component={motion.div}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={containerVariants}
    >
      <Typography variant="h4" align="center" gutterBottom>
        Skills
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: 1,
          mt: 2,
        }}
      >
        {skills.map((skill, index) => (
          <motion.div key={index} variants={chipVariants}>
            <Chip label={skill} variant="outlined" />
          </motion.div>
        ))}
      </Box>
    </Container>
  );
};

export default Skills;
